import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Briefcase, 
  Calendar, 
  CreditCard, 
  DollarSign,
  User,
  LogOut,
  History,
  Bed,
  Archive,
} from 'lucide-react';
import { useAuth } from '@/contexts/auth-context';

export function Sidebar() {
  const { user, signOut } = useAuth();
  const activeClassName = "bg-blue-100 text-blue-600";
  const inactiveClassName = "text-gray-500 hover:text-blue-600 hover:bg-blue-50";

  const getNavLinkClass = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-3 rounded-lg px-3 py-2 transition-all text-base font-medium ${isActive ? activeClassName : inactiveClassName}`;

  return (
    <div className="hidden border-r bg-white md:block">
      <div className="flex h-full max-h-screen flex-col gap-2">
        <div className="flex h-14 items-center border-b px-4 lg:h-[60px] lg:px-6">
          <NavLink to="/" className="flex items-center gap-2 font-semibold text-gray-800">
            <LayoutDashboard className="h-6 w-6 text-blue-600" />
            <span>Clinic365</span>
          </NavLink>
        </div>
        <div className="flex-1 overflow-y-auto">
          <nav className="grid items-start px-2 text-sm font-medium lg:px-4">
            <NavLink to="/app/dashboard" className={getNavLinkClass}>
              <LayoutDashboard className="h-4 w-4" />
              Dashboard
            </NavLink>
            <NavLink to="/app/appointments" className={getNavLinkClass}>
              <Calendar className="h-4 w-4" />
              Appointments
            </NavLink>
            <NavLink to="/app/calendar" className={getNavLinkClass}>
              <Calendar className="h-4 w-4" />
              Calendar
            </NavLink>
            <NavLink to="/app/patients" className={getNavLinkClass}>
              <Users className="h-4 w-4" />
              Patients
            </NavLink>
            <NavLink to="/app/doctors" className={getNavLinkClass}>
              <Briefcase className="h-4 w-4" />
              Doctors
            </NavLink>
            <NavLink to="/app/patient-history" className={getNavLinkClass}>
              <History className="h-4 w-4" />
              Patient History
            </NavLink>
             <NavLink to="/app/admitted-patients" className={getNavLinkClass}>
              <Bed className="h-4 w-4" />
              Admitted Patients
            </NavLink>
             <NavLink to="/app/payments" className={getNavLinkClass}>
              <CreditCard className="h-4 w-4" />
              Payments
            </NavLink>
            <NavLink to="/app/daily-expense" className={getNavLinkClass}>
              <DollarSign className="h-4 w-4" />
              Daily Expense
            </NavLink>
            <NavLink to="/app/inventory" className={getNavLinkClass}>
              <Archive className="h-4 w-4" />
              Inventory
            </NavLink>
            <NavLink to="/app/billing" className={getNavLinkClass}>
              <CreditCard className="h-4 w-4" />
              Billing
            </NavLink>
          </nav>
        </div>
        <div className="mt-auto p-4 border-t">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
              <User className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm font-semibold leading-none text-gray-800">{user?.user_metadata.full_name}</p>
              <p className="text-xs leading-none text-muted-foreground">{user?.email}</p>
            </div>
          </div>
          <button onClick={signOut} className="flex items-center gap-3 rounded-lg px-3 py-2 mt-4 text-sm w-full text-left text-gray-500 hover:text-red-600 hover:bg-red-50 transition-all">
            <LogOut className="h-4 w-4" />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
} 